import { css } from 'styled-components'

/**
 * These aren't explicitly defined anywhere, but I'm adding
 * them since they're used commonly enough
 */

export const SolidSlimBorder = css`
  border-style: solid;
  border-width: 1px;
`

export const SolidBoldBorder = css`
  border-style: solid;
  border-width: 2px;
`

export const XLRounding = css`
  border-radius: 12px;
`

export const LargeRounding = css`
  border-radius: 8px;
`

export const NormalRounding = css`
  border-radius: 6px;
`

export const MiniRounding = css`
  border-radius: 4px;
`
